<script>
import { ConfettiPasswordInput } from "@kci/confetti-vue";
import { MIN_PW_LENGTH } from "@/helpers/validations";

export default {
  name: "RegistrationInput",
  components: {
    ConfettiPasswordInput,
  },

  props: {
    errorOverride: {
      type: String,
      default: "",
    },

    label: {
      type: String,
      required: true,
    },

    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return { error: "", password: "" };
  },

  computed: {
    errorMessage() {
      return this.errorOverride || this.error;
    },

    iconName() {
      if (this.errorMessage) {
        return "exclamation-square-o";
      } else {
        return this.password ? "check-o" : "";
      }
    },

    iconType() {
      if (this.errorMessage) {
        return "error";
      } else {
        return this.password ? "check" : "";
      }
    },
  },

  methods: {
    validate() {
      this.error =
        this.password && this.password.length < MIN_PW_LENGTH
          ? this.$t("Password must be at least {min} characters", {
              min: MIN_PW_LENGTH,
            })
          : "";

      this.$emit("validate", this.password);
    },
  },
};
</script>

<template>
  <ConfettiPasswordInput
    v-model="password"
    v-debounce:500="validate"
    :additional-icon-name="iconName"
    :additional-icon-type="iconType"
    debounce-events="input"
    :error-message="errorMessage"
    :hide-eye-icon="!!iconType"
    :is-error="!!errorMessage"
    is-required
    :label="label"
    :name="name"
  />
</template>
